// Paleta e opções padrão dos gráficos ApexCharts do módulo de Solicitações — extraídas de
// RelatorioPromocoes.jsx/DashboardCharts.jsx para manter a mesma identidade visual em todo dashboard novo.
export const CORES_GRAFICO = ["#3B82F6", "#8B5CF6", "#10B981", "#F59E0B", "#EF4444", "#0EA5E9", "#EC4899"];

export function donutOptions(labels, extra = {}) {
    return {
        labels,
        colors: CORES_GRAFICO,
        legend: { position: "bottom", fontSize: "12px" },
        plotOptions: { pie: { donut: { size: "50%" } } },
        stroke: { show: false },
        ...extra,
    };
}

export function barOptions(categorias, extra = {}) {
    return {
        xaxis: { categories: categorias, labels: { style: { fontSize: "11px" } } },
        colors: ["#0EA5E9"],
        legend: { show: false },
        plotOptions: { bar: { borderRadius: 4, columnWidth: "35%" } },
        dataLabels: { enabled: false },
        ...extra,
    };
}

/** KPIs padrão (Total/Pendentes/Finalizadas/Canceladas) dos dashboards de processo "simples". */
export function kpisBasicos(dashboard, iconTotal = "fa fa-list") {
    return [
        { label: "Total de solicitações", value: dashboard?.total ?? 0, icon: iconTotal, iconClassName: "bg-primary/10 text-primary", colspan: 'lg:col-span-2' },
        { label: "Pendentes", value: dashboard?.pendentes ?? 0, icon: "fa fa-clock", iconClassName: "bg-amber-100 text-amber-700", colspan: 'lg:col-span-2' },
        { label: "Finalizadas", value: dashboard?.finalizadas ?? 0, icon: "fa fa-check-circle", iconClassName: "bg-success/10 text-success", colspan: 'lg:col-span-2'},
        { label: "Canceladas", value: dashboard?.canceladas ?? 0, icon: "fa fa-times-circle", iconClassName: "bg-destructive/10 text-destructive" , colspan: 'lg:col-span-2'},
    ];
}
